<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-button-goto ttText="stockcounts_new" ttGoto="stockcount" [ttGotoParms]="{ stockplace_id: setting.stockplace_id, stockcount_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
            <tt-select ttRememberId="stockcounts.stockplace_id" ttLabel="stockplace" [(ttModel)]="setting.stockplace_id" (ttModelChange)="onChanged($event, 'stockplace_id')" [ttData]="selectListStockPlaces" ttDataId="stockplace_id" ttDataName="stockplace_name"></tt-select>

            <tt-tabs [(ttSelectedId)]="setting.bg_stockcount_status" (ttSelectedIdChange)="onTabChange()">
                <tt-tab ttId="OPEN" ttLabel="bg_stockcount_status_open"></tt-tab>
                <tt-tab ttId="CLOSED" ttLabel="bg_stockcount_status_closed"></tt-tab>
            </tt-tabs>
        </tt-card>

        <tt-list [ttData]="itemsListStockCounts"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <tt-select ttRememberId="stockcounts.stockplace_id" ttLabel="stockplace" [(ttModel)]="setting.stockplace_id" (ttModelChange)="onChanged($event, 'stockplace_id')" [ttData]="selectListStockPlaces" ttDataId="stockplace_id" ttDataName="stockplace_name"></tt-select>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <tt-button-goto ttText="stockcounts_new" ttGoto="stockcount" [ttGotoParms]="{ stockplace_id: setting.stockplace_id, stockcount_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
            </tt-card>
        </div>

        <div class="col-xs-12 col-md-6 p-5">
            <tt-card>
                <tt-tabs [(ttSelectedId)]="setting.bg_stockcount_status" (ttSelectedIdChange)="onTabChange()">
                    <tt-tab ttId="OPEN" ttLabel="bg_stockcount_status_open"></tt-tab>
                    <tt-tab ttId="CLOSED" ttLabel="bg_stockcount_status_closed"></tt-tab>
                </tt-tabs>
            </tt-card>

            <tt-list [ttData]="itemsListStockCounts"></tt-list>
        </div>
    </div>
</tt-page>
